<div class="relative">
  @if (alertText) {
    <div class="alert-bubble" [style.background-color]="alertColour"
      [style.color]="alertColour ? 'white' : ''">
      {{ alertText }}
    </div>
  }
  <app-profile-picture [class]="class" [fitMedProfileId]="fitMedProfile?.id"></app-profile-picture>
</div>
